<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-checkbox label="Tự động nhận lô hàng" v-model="autoImportBigpackage"></v-checkbox>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td v-bind:style="{ 'color': item.ReceivedWeight > 0 ? '' : 'red' }">{{ item.PackageCode }}</td>
                <td v-bind:style="{ 'color': display_color(item.Status, bigPackageStatus)}">{{ item.Status | display_value(bigPackageStatus) }}</td>
                <td v-bind:style="{ 'color': display_color(item.State, bigPackageState)}">{{ item.State | display_value(bigPackageState) }}</td>
                <td class="text-right">{{ item.Weight }}</td>
                <td class="text-right font-weight-bold">{{ item.ReceivedWeight }}</td>
                <td class="text-right">{{ item.Volume }}</td>
                <td class="text-right font-weight-bold">{{ item.ReceivedPacks }}</td>
                <td class="text-right" v-if="adminRole || paymentRole">{{ item.Amount | currency }}</td>
                <td class="text-right" v-else></td>
                <td>{{ item.ImDate | display_date }}</td>
                <td>{{ item.CreatedBy }}</td>
                <td class="text-center">
                  <v-tooltip top v-if="item.Status == bigPackageEnum.DA_CHUYEN">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" medium class="mr-2" @click="importPackage(item.ID, item.PackageCode)">fa-check</v-icon>
                    </template>
                    <span>Nhận lô hàng</span>
                  </v-tooltip>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" medium class="mr-2" @click="gotoDetail(item.ID)">fa-external-link-alt</v-icon>
                    </template>
                    <span>Chi tiết lô hàng</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import moment from "moment"
import { getCurrentTime, sendErrorNotice } from "@/commons/utils";
import { display_color } from "@/commons/formater";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      autoImportBigpackage: false,
      display_color: display_color,
      headers: [
        {
          text: "Lô hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.BIG_PACKAGE_STATUS,
          width: 120
        },
        {
          text: "Tình trạng",
          value: "State",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.BIG_PACKAGE_STATE,
          width: 120
        },
        {
          text: "Cân nặng (TQ)",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Cân nặng đã nhập",
          value: "ReceivedWeight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Số khối (TQ)",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Số kiện đã nhập",
          value: "ReceivedPacks",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí ship",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ngày nhập",
          value: "ImDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Người nhập",
          value: "CreatedBy",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ExDate"], sortDesc: [true]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      bigPackageStatus: configs.BIG_PACKAGE_STATUS,
      bigPackageEnum: configs.BIG_PACKAGE_STATUS_ENUM,
      bigPackageState: configs.BIG_PACKAGE_STATE,
      viewName: "bigpackagevn_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogPackageDetail: false,
      currentTime: getCurrentTime()
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    items: {
      handler: function(val, oldVal) {
        if(this.autoImportBigpackage && this.items.length == 1 && this.quickFilterConditions.length == 1  && this.items[0].Status == this.bigPackageEnum.DA_CHUYEN && this.items[0].PackageCode == this.quickFilterConditions[0].value) {
          this.saveItem({
            ID: this.items[0].ID,
            Status: configs.BIG_PACKAGE_STATUS_ENUM.DA_NHAN
          });
          this.gotoDetail(this.items[0].ID);
        }
      },
      deep: true
    },
  },
  computed: {
    ...mapState({
      items: state => state.bigPackage.all.data,
      total_rows: state => state.bigPackage.all.total,
      currentItem: state => state.bigPackage.selected,
      notTransit: state => state.bigPackage.notTransit,
      loading: state => state.bigPackage.loading
    }),
    param() {
      let pr = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      pr.filter.push({
        column: "Status",
        value: [configs.BIG_PACKAGE_STATUS_ENUM.DA_NHAN, configs.BIG_PACKAGE_STATUS_ENUM.DA_CHUYEN],
        condition: "in"
      });
      return pr;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    paymentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
  },
  methods: {
    filter_data: function() {
      this.$store.dispatch("bigPackage/getList", this.param);
    },
    gotoDetail: function (id) {
      this.$store.commit("bigPackage/setDetail", {
        data: {
          ID: 0,
          CreatedDate: new Date(),
          PackageCode: '',
          Weight: 0,
          Volume: 0,
          Amount: 0
        }
      });
      this.$router.push({
        name: "StoreManagerVNDetail",
        params: {
        Pid: id,
        title: 'Chi tiết nhập kho'
        }
      });
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$store.commit("bigPackage/setDetail", {
        data: {
          ID: 0,
          ImDate: new Date(),
          PackageCode: '',
          BigPackageID: -1,
          Weight: 0,
          Volume: 0,
          Amount: 0
        }
      });
      this.$router.push({
          name: "StoreManagerVNDetail",
          params: {
          Pid: 'nhap-bao-moi',
          title: 'Nhập lô mới'
          }
      });
    },
    saveItem(item) {
      this.$store.dispatch("bigPackage/setDetail", {
        data: item,
        id: item.ID
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    closePopup() {
      this.dialogPackageDetail = false;
      this.filter_data();
    },
    getListPackageNotTran() {
      this.$store.dispatch("bigPackage/getListNotTransit");
    },
    importPackage(id, package_code) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'ImportStoreVN', id, `Bạn có chắc chắn nhận lô hàng ${package_code} không?`);
    },
  },
  mounted() {
    this.getListPackageNotTran();
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bigPackage/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
    this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
      if(action == 'ExportStoreCN') {
        this.saveItem({
          ID: id,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.DA_CHUYEN
        });
      }
      else if(action == 'UnExportStoreCN') {
        this.saveItem({
          ID: id,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.CHUA_CHUYEN
        });
      }
      else if(action == 'ImportStoreVN') {
        this.saveItem({
          ID: id,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.DA_NHAN
        });
        this.gotoDetail(id);
      }
      else if(action == 'PayPackage') {
        this.saveItem({
          ID: id,
          PaymentStatus: 1
        });
      }
      else if(action == 'UnPayPackage') {
        this.saveItem({
          ID: id,
          PaymentStatus: 0
        });
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
    this.$root.$off("CONFIRMED_ACTION");
  }
};
</script>
